module.exports = __webpack_public_path__ + "img/ethan_hawk.8b403959.jpg";